// These labels are used in the LabelValue component to determine which metrics should be limited based on the user's plan. If a label is included in this list, it means that access to that metric is restricted for users without the appropriate plan.
export const getLimitedLabels = [
  "Annual gain/loss",
  "Annual change value",
  "Condition",
  "Lifetime gain/loss",
  "Max drawdown",
  "Sharpe ratio(1y)",
  "Sharpe ratio (1Y)",
  "Time to recovery",
];

// Car table columns that require a paid plan (garage_risk_kpis) to access.
export const KPI_COLUMNS_BASE = ["annual_gain_lost", "lifetime_gain_lost"] as const;

// Additional columns locked on the starter plan.
export const KPI_COLUMNS_FREE = ["condition", ...KPI_COLUMNS_BASE] as const;
